import { useContext, useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { useIntercom } from "react-use-intercom";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

import ServiceList from "../../components/service-list/ServiceList";
import { getAllServices } from "../../services/MedicalService";
import { getOrganizationByQuery } from "../../services/OrganizationService";
import { BookingContext } from "../../providers/BookingProvider";
import { ProductType } from "../../services/types";
import styles from "./home.module.scss";

const Home = () => {
  // global state booking
  const { booking, setBooking, organization, setOrganization } =
    useContext<any>(BookingContext);

  // availabel services of medical center
  const [products, setMedicalServices] = useState<ProductType[]>([]);

  // user selected service
  const [selectedProducts, setSelectedProducts] = useState<ProductType[]>([]);

  // loading
  const [loading, setLoading] = useState(true);

  const history = useHistory();

  // intercom hook
  const { boot } = useIntercom();

  // set organization name to intercom
  const bootWithProps = (orgName) => {
    boot({
      customAttributes: {
        organization: orgName,
      },
    });
  };

  // to get url params
  const { orgName: orgNameURL } = useParams();

  // get initial availabel services
  useEffect(() => {
    setLoading(true);
    async function fetchData() {
      // get orgazanization
      const org = await getOrganizationByQuery(orgNameURL);

      // set location as global state (because it's used on the next pages)
      if (org) setOrganization(org);

      // when organization is not at registered
      const services = org ? await getAllServices(org.id) : [];
      setMedicalServices(services);

      // update organization state if org is defined
      if (org) {
        bootWithProps(org.name);
        setOrganization(org);
      }

      setLoading(false);
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // when a user select a service
  const selectProduct = (product: ProductType) => {
    // TODO: add option to remove product from selected ones
    const idx = selectedProducts.findIndex((prod) => prod.id === product.id);
    // product is not selected yet
    if (idx === -1) {
      setSelectedProducts([...selectedProducts, product]);
    }
  };

  // when a user want to book a service
  const goToAppointment = () => {
    // set global booking
    setBooking({ ...booking, products: selectedProducts });
    history.push("c/cita");
  };

  return (
    <Container style={{ paddingTop: 60 }}>
      <Grid container spacing={5}>
        {/* form to book a service */}
        <Grid item xs={12} md={7} style={{ paddingLeft: "6rem" }}>
          {/* organization name */}
          {!loading ? (
            organization && (
              <Typography
                color={"secondary"}
                variant={"h4"}
                component={"h4"}
                style={{ marginBottom: 20 }}
              >
                {organization.name}
              </Typography>
            )
          ) : (
            <CircularProgress style={{ margin: 20 }} />
          )}

          {/* title */}
          <Grid container item spacing={1} alignItems="flex-end">
            <Typography color={"primary"} variant={"body1"} component={"h2"}>
              Aquí podrás cotizar y reservar tus servicios domiciliarios 100%
              online ¡Es muy sencillo!
            </Typography>
            <Typography
              color={"primary"}
              variant={"body1"}
              component={"p"}
              style={{ marginTop: 50 }}
            >
              Selecciona el servicio que necesites:
            </Typography>
          </Grid>

          {/* list of medical services */}
          <Grid
            container
            spacing={2}
            item
            style={{ marginTop: 50, textAlign: "center" }}
          >
            {!loading ? (
              <ServiceList
                products={products}
                onSelectProduct={selectProduct}
                selectedProducts={selectedProducts}
              />
            ) : (
              <CircularProgress style={{ margin: 20 }} />
            )}
          </Grid>

          {/* button to ask for the service*/}
          <Grid container item>
            <Grid item>
              <Button
                className={styles.request_button}
                variant={"contained"}
                color={"secondary"}
                disableElevation={true}
                size={"large"}
                style={{ textTransform: "unset" }}
                disabled={selectedProducts.length === 0}
                onClick={goToAppointment}
              >
                Solicitar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Home;
